import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertPartyInward = createAsyncThunk('insertPartyInward', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPartyInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updatePartyInward = createAsyncThunk('updatePartyInward', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updatePartyInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPartyInwMemo = createAsyncThunk('fetchPartyInwMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartyInwardmemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPartyInwardData = createAsyncThunk('fetchPartyInwardData', async (id) => {
    try {
        const endpoint = id ? `getPartyInwardlist&pinwId=${id}` : 'getPartyInwardlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPartyInwardMemo = createAsyncThunk('fetchPartyInwardMemo', async (id) => {
    try {
        const endpoint = id ? `getPartyInwardlist&piMemo=${id}` : 'getPartyInwardlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPackingSlipMemo3 = createAsyncThunk('fetchPackingSlipMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPackingSlipMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPackingData3 = createAsyncThunk('fetchPackingData', async (id) => {
    try {
        const endpoint = id ? `getPackingEntryData&pkId=${id}` : 'getPackingEntryData';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleInvoiceReg3 = createAsyncThunk('fetchSaleInvoiceReg', async (id) => {
    try {
        const endpoint = id ? `getPackingInvoiceRegister&invId=${id}` : 'getPackingInvoiceRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deletePartyInward = createAsyncThunk('deletePartyInward', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deletePartyInward&pinwId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const partyInwApiSlice = createSlice({
    name: 'PartyInwData',
    initialState: {
        isLoading: false,
        pimemo: null,
        partyinw: null,
        partyinw2: null,
        delpinw: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPartyInwMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPartyInwMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pimemo = action.payload;
        });
        builder.addCase(fetchPartyInwMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchPartyInwardData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPartyInwardData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.partyinw = action.payload;
        });
        builder.addCase(fetchPartyInwardData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        

        builder.addCase(deletePartyInward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deletePartyInward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delpinw = action.payload;
        });
        builder.addCase(deletePartyInward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPartyInwardMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPartyInwardMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.partyinw2 = action.payload;
        });
        builder.addCase(fetchPartyInwardMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default partyInwApiSlice.reducer;
